import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class IdentidadeVisualService {

  constructor(private http: HttpClient) { }

  consultarIdentidadeVisual() {
    return this.http.get<any>(globals.apiUrl + '/api/IdentidadeVisual');
  }

  salvarCores(cores: { corPrincipal: string, corSecundaria: string }) {
    return this.http.put(globals.apiUrl + '/api/IdentidadeVisual/Cores', cores);
  }

  salvarArquivo(controllerUrl: string, logo: string) {
    return this.http.post(globals.apiUrl + '/api/IdentidadeVisual/'+ controllerUrl, {
      arquivoBase64: logo
    });
  }
}
